import { useMemo } from 'react';
import { encode } from 'uqr';

/**
 * Dark modules as one SVG path, one rectangle per run of dark modules in a row.
 * Exported for tests.
 */
export function qrPath(data: readonly (readonly boolean[])[]): string {
  let path = '';
  data.forEach((row, y) => {
    let x = 0;
    while (x < row.length) {
      if (!row[x]) {
        x += 1;
        continue;
      }
      const start = x;
      while (x < row.length && row[x]) x += 1;
      path += `M${start} ${y}h${x - start}v1h${start - x}z`;
    }
  });
  return path;
}

/**
 * A QR code drawn on this device. The value (an otpauth link with the TOTP
 * secret) never leaves the page, unlike QR image services. Black on white in
 * both themes, with the four-module quiet zone scanners expect.
 */
export function QrCode({ value, label, size = 176 }: { value: string; label: string; size?: number }) {
  const { path, modules } = useMemo(() => {
    const qr = encode(value, { ecc: 'M', border: 4 });
    return { path: qrPath(qr.data), modules: qr.size };
  }, [value]);
  return (
    <svg
      role="img"
      aria-label={label}
      viewBox={`0 0 ${modules} ${modules}`}
      width={size}
      height={size}
      shapeRendering="crispEdges"
      style={{ display: 'block', borderRadius: 12, boxShadow: '0 0 0 1px var(--line)', flex: 'none' }}
    >
      <rect width={modules} height={modules} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
